<template>
  <footer class="footer">
    <div class="container">
      <div class="footer-content">
        <div class="footer-section">
          <h3>关于我们</h3>
          <p>长春合利水土保持科技有限公司是一家专业从事水土保持监测仪器研发、生产、销售及服务的高新技术企业，致力于为客户提供生态环境自动化监测设备、水土保持技术服务、定制化软件开发及数字一体化智能解决方案。</p>
        </div>
        <div class="footer-section">
          <h3>快速链接</h3>
          <ul>
            <li><a href="http://www.mwr.gov.cn" target="_blank">中华人民共和国水利部</a></li>
            <li><a href="http://www.swcc.org.cn" target="_blank">中国水土保持生态建设网</a></li>
          </ul>
        </div>
        <div class="footer-section">
          <h3>数据云平台</h3>
          <ul>
            <li><a href="http://223.75.53.0:8037" target="_blank">湖北省数据云平台</a></li>
            <li><a href="http://yun.hl2013.com" target="_blank">全国数据云平台</a></li>
          </ul>
        </div>
        <div class="footer-section">
          <h3>联系方式</h3>
          <p>地址：长春市经济开发区联东U谷·长春经开国际企业港4栋103号楼</p>
          <p>电话：姜经理 18844162277 / 吴经理 18943648307</p>
          <p>工作时间：周一至周五 9:00 - 17:30</p>
        </div>
      </div>
      <div class="footer-bottom">
        <p>&copy; 2026 长春合利水土保持科技有限公司 版权所有</p>
      </div>
    </div>
  </footer>
</template>

<script>
export default {
  name: 'AppFooter'
}
</script>

<style scoped>
.footer {
  background: #2c3e50;
  color: #fff;
  padding: 40px 0 20px;
  margin-top: 60px;
}

.container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
}

.footer-content {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 30px;
  margin-bottom: 30px;
}

.footer-section h3 {
  font-size: 18px;
  margin-bottom: 15px;
  color: #1890ff;
}

.footer-section p {
  font-size: 14px;
  line-height: 1.8;
  color: #bdc3c7;
}

.footer-section ul {
  list-style: none;
  padding: 0;
  margin: 0;
}

.footer-section li {
  margin-bottom: 10px;
}

.footer-section a {
  color: #bdc3c7;
  text-decoration: none;
  font-size: 14px;
  transition: color 0.3s;
}

.footer-section a:hover {
  color: #1890ff;
}

.footer-bottom {
  border-top: 1px solid #34495e;
  padding-top: 20px;
  text-align: center;
}

.footer-bottom p {
  font-size: 14px;
  color: #95a5a6;
  margin: 0;
}

@media (max-width: 768px) {
  .footer-content {
    grid-template-columns: 1fr;
  }
}
</style>
